import React from 'react';
import Card from '../../../../Presentation/components/ui/Card';
import AppInput from '../../../../Presentation/components/ui/AppInput';
import AppSelect from '../../../../Presentation/components/ui/AppSelect';
import {Search} from 'lucide-react';
import {UserStatus} from '../../models/user.model';

interface UsersListFiltersProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  roleFilter: number;
  onRoleFilterChange: (value: number) => void;
}

const STATUS_FILTER_OPTIONS = [
  {value: '', label: 'جميع الحالات'},
  {value: UserStatus.ACTIVE, label: 'نشط'},
  {value: UserStatus.INACTIVE, label: 'غير نشط'},
  {value: UserStatus.SUSPENDED, label: 'معلق'},
  {value: UserStatus.PENDING, label: 'في الانتظار'}
];

const ROLE_FILTER_OPTIONS = [
  {value: 0, label: 'جميع الأدوار'},
  {value: 1, label: 'مدير'},
  {value: 3, label: 'مزود خدمة'}
  // Note: Add these when database roles are available:
  // { value: 4, label: 'مدير عام' },
  // { value: 5, label: 'مدير' },
  // { value: 6, label: 'محاسب' },
  // { value: 7, label: 'مراقب' },
];

export const UsersListFilters: React.FC<UsersListFiltersProps> = ({
  searchValue,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  roleFilter,
  onRoleFilterChange
}) => {
  return (
    <Card className="p-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <AppInput
              type="text"
              placeholder="بحث في المستخدمين..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>
        <div className="flex gap-3">
          <AppSelect
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            options={STATUS_FILTER_OPTIONS}
          />
          <AppSelect
            value={roleFilter}
            onChange={(e) => onRoleFilterChange(parseInt(e.target.value))}
            options={ROLE_FILTER_OPTIONS}
          />
        </div>
      </div>
    </Card>
  );
};
